// src/lib/training/trainingPanelLogic.ts
import { getSpeakMode, getVoiceEnabled } from "../speech/voiceSettings";

export const LOW_CONFIDENCE_SCORE_THRESHOLD = 0.72;

export function shouldSpeakAnswers(): boolean {
  const speakMode = getSpeakMode();
  return getVoiceEnabled() && (speakMode === "answers" || speakMode === "all");
}

export function clampForSpeech(s: string, max = 420): string {
  const t = (s || "").trim();
  if (!t) return "";
  if (t.length <= max) return t;
  return t.slice(0, max - 1) + "…";
}

export function isDirectContactIntent(q: string, isLocationLookupIntent: (q: string) => boolean): boolean {
  const s = (q || "").toLowerCase();
  const compact = s.replace(/[’']/g, "").replace(/\s+/g, " ").trim();

  const phrases = [
    "who do i talk to",
    "who should i talk to",
    "who do i contact",
    "who should i contact",
    "who do i call",
    "who handles",
    "who is responsible",
    "what's the number for",
    "whats the number for",
    "what is the phone number for",
    "who do we call",
    "i need to talk to someone",
    "i need to talk to somebody",
    "i have a question",
  ];
  if (
    phrases.some((p) => {
      const pp = p.toLowerCase().replace(/[’']/g, "").replace(/\s+/g, " ").trim();
      return compact.includes(pp);
    })
  ) {
    return true;
  }

  // Treat explicit location lookups as contact intent
  if (isLocationLookupIntent(q)) return true;

  // Contact-info keywords + place-ish cue
  const contactWords = ["phone", "number", "address", "email", "contact", "manager", "hours"];
  const hasContactWord = contactWords.some((w) => s.includes(w));

  const hasPlaceCue =
    s.includes("location") || s.includes("lot") || s.includes("office") || s.includes(" in ") || s.includes(" at ");

  return hasContactWord && hasPlaceCue;
}

// Surface contacts when KB returned grounded chunks but match confidence is low — not when KB has nothing (no_answer).
// Otherwise definitional questions (e.g. “What is a lead in our CRM?”) get irrelevant contacts after an empty KB hit.
export function shouldSuggestContactsFromKb(out: any, lowConfidenceThreshold = LOW_CONFIDENCE_SCORE_THRESHOLD): boolean {
  if (!out) return false;
  if (out.mode === "no_answer") return false;

  const top = (out.sources || [])
    .map((s: any) => Number(s.score || 0))
    .sort((a: number, b: number) => b - a)[0];

  if (!Number.isFinite(top)) return false;
  return top < lowConfidenceThreshold;
}
